import {createSlice, type SliceSelectors} from '@reduxjs/toolkit'

import {addException, removeException, setFailureException, getInitialState} from '@web/slices/error/slice'

import type {ErrorReducers, MakeCreateSliceOptions} from './interfaces'
import type {ErrorState} from '@web/slices/error/slice'

export default (options?: MakeCreateSliceOptions) =>
    createSlice<ErrorState, ErrorReducers<ErrorState>, 'error', SliceSelectors<ErrorState>>({
        name: 'error',
        initialState: getInitialState(),
        reducers: {
            setFailure: (state, {payload}) => {
                state.failureCase = payload
            },
            resetFailure: (state) => {
                state.failureCase = {...getInitialState().failureCase}
            },
            addException: (state, {payload: error}) => {
                state.exceptionCodeMap = {
                    ...state.exceptionCodeMap,
                    [error.code]: error,
                }
            },
            removeException: (state, {payload: errorType}) => {
                delete state.exceptionCodeMap[errorType]
            },
            reset: () => getInitialState(),
        },
        extraReducers: (builder) => {
            builder.addCase(setFailureException, (state, {payload}) => {
                state.failureCase = payload
            })
            builder.addCase(addException, (state, {payload: error}) => {
                state.exceptionCodeMap = {
                    ...state.exceptionCodeMap,
                    [error.code]: error,
                }
            })
            builder.addCase(removeException, (state, {payload: errorType}) => {
                delete state.exceptionCodeMap[errorType]
            })

            options?.extraReducers?.(builder)
        },
    })
